import { css } from 'styled-components';
import { rem, media } from '../../../helpers/mixins';
import arrowDown from '../../../assets/images/icons/arrowDown.svg';
import arrowDownBlack from '../../../assets/images/icons/arrowDownBlack.svg';
import { PURPLE, WHITE } from '../../../constants/colors';

export default {
  select: ({ isMobile }) => css`
    position: relative;
    color: ${PURPLE};
    font-size: ${isMobile ? rem('16px') : rem('14px')};
    width: ${isMobile ? 'calc(100% - 16px)' : '100%'};
    border: none;
    box-shadow: none;
    border-radius: 0;
    background-color: transparent;
    background-image: none;
    appearance: none;
    outline: none;
    border-bottom: 1px solid ${PURPLE};
    padding-right: 24px;
    ${media.sm`
    color: ${WHITE};
    border-bottom: 1px solid ${WHITE};
    `};
    option {
      color: black;
    }
  `,
  selectArrow: ({ isMobile }) => css`
    position: absolute;
    bottom: 8px;
    right: ${isMobile ? 16 : 4}px;
    width: 10px;
    height: 6px;
    background-image: url(${arrowDownBlack});
    ${media.sm`
    background-image: url(${arrowDown});
    `};
    background-repeat: no-repeat;
    pointer-events: none;
  `,
  selectWrapper: css`
    position: relative;
  `
};
